module.exports = __webpack_public_path__ + "media/images/emblems/La_Brevine-coat_of_arms-5db046a26c73034c582caa9fd6b2e7f7.svg";